/* AiFieldBadge — tag visual para campos preenchidos por IA.
 *
 * Mostra "Sugerido por IA" (amarelo) ou "Revisado pelo pesquisador"
 * (verde) e permite alternar entre estados com um clique.
 */
import { Sparkles, CheckCircle2 } from "lucide-react";

export default function AiFieldBadge({ status, onReview, compact = false, testid }) {
  if (!status) return null;
  const reviewed = status === "reviewed";

  const base =
    "inline-flex items-center gap-1 rounded-full border font-medium uppercase tracking-wide transition select-none";
  const size = compact ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-0.5";

  if (reviewed) {
    return (
      <span
        className={`${base} ${size} bg-emerald-50 dark:bg-emerald-950/30 text-emerald-700 dark:text-emerald-300 border-emerald-300/60 dark:border-emerald-700/50`}
        data-testid={testid || "ai-badge-reviewed"}
        title="Revisado pelo pesquisador"
      >
        <CheckCircle2 size={10} />
        Revisado
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={onReview}
      className={`${base} ${size} bg-amber-50 dark:bg-amber-950/30 text-amber-700 dark:text-amber-300 border-amber-300/60 dark:border-amber-700/50 hover:bg-amber-100 dark:hover:bg-amber-900/40 cursor-pointer`}
      data-testid={testid || "ai-badge-suggested"}
      title="Clique para marcar como revisado pelo pesquisador"
    >
      <Sparkles size={10} />
      Sugerido por IA
    </button>
  );
}
